import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getBlogListSucceed, requestFailure } from '../actions'
import { AxiosError } from 'axios'

export function* getBlogListSaga(
  blogApi: {
    getBlogList: (...args: any[]) => any
  },
  {
    payload: { page, limit, sortBy, sortDirection, q }
  }: {
    payload: {
      page?: number
      limit?: number
      sortBy?: string
      sortDirection?: string
      q?: string
    }
  }
) {
  try {
    const { data } = yield call(
      blogApi.getBlogList,
      page,
      limit,
      sortBy,
      sortDirection,
      q
    )
    yield put(getBlogListSucceed(data))
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'isAxiosError' in error) {
      yield handleUnAuthorizedError(error as AxiosError)
      yield put(requestFailure(error))
    } else {
      yield put(requestFailure(error))
    }
  }
}
